import { Student } from '@df/interfaces';

export function sortLetters(students: Array<Student>): Array<string> {
    const letters: Array<string> = [];

    students.forEach((student: Student) => {
        const letter: string = student.short_name ? student.short_name.charAt(0) : student.name.charAt(0);
        if (!letters.includes(letter)) {
            letters.push(letter);
        }
    });

    return letters.sort((let1, let2) => (let1 > let2 ? 1 : -1));
}

export function convertDateToReadableString(date: string): string {
    return date.replace('T', ' ');
}
